import types from 'constants/actionTypes';

export const addActiveFilters = (functionalGroupId, filters, designOption) => {
  return {
    type: types.ADD_DESIGN_OPTION_FILTER,
    payload: { functionalGroupId, filters, designOption },
  };
};

export const removeFilter = (
  functionalGroupId,
  designOption,
  newSelectedOptions,
) => {
  return {
    type: types.REMOVE_DESIGN_OPTION_FILTER,
    payload: { functionalGroupId, designOption, newSelectedOptions },
  };
};

export const clearFilters = functionalGroupId => {
  return {
    type: types.CLEAR_DESIGN_OPTION_FILTERS,
    payload: { functionalGroupId },
  };
};

export const clearAllDesignOptionFilters = () => {
  return {
    type: types.CLEAR_ALL_DESIGN_OPTION_FILTERS,
  };
};

export const clearAllLocalFilters = () => {
  return {
    type: types.CLEAR_ALL_LOCAL_FILTERS,
  };
};
